import React from "react";
import { useNavigate } from "react-router-dom";

function AfterSignInPage() {
  const navigate = useNavigate();

  React.useEffect(() => {
    const lastSearchUrl = sessionStorage.getItem("lastSearchUrl");
    if (lastSearchUrl) {
      navigate(lastSearchUrl, { replace: true });
    } else {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  return null;
}

export default AfterSignInPage;
